import { useMemo } from "react";
import Lottie from "react-lottie";

import StickyButton from "@/common/StickyButton";
import chartFemale from "@/female/assets/lottie/lasting_results.json";
import i18n from "@/localization/i18next";
import chartMale from "@/male/assets/lottie/lasting_results.json";
import { HandleNext } from "@/types/common";
import { useGender } from "@/utils/GenderProvider";

interface PromoZingAiProps {
    handleNext: HandleNext;
    isActive: boolean;
}
const PromoZingAi = ({ handleNext, isActive }: PromoZingAiProps) => {
    const { isFemale } = useGender();

    const chart = useMemo(() => (isFemale ? chartFemale : chartMale), [isFemale]);

    return (
        <div className="grid h-full grow content-between gap-8">
            <div className="grid gap-10">
                <div className="grid gap-4 text-white female:text-black">
                    <div className="text-zing-24-32 font-semibold">See Lasting Results</div>
                    <div className="">
                        Zing AI promotes healthy habits, behavior change and movement, not
                        restrictive diets.
                    </div>
                </div>
                <div className="-mx-1 md:mx-0">
                    <Lottie
                        options={{
                            animationData: chart,
                            loop: false,
                            autoplay: false,
                        }}
                        isPaused={!isActive}
                        isClickToPauseDisabled
                    />
                </div>
            </div>
            <StickyButton className="bottom-0" onClick={() => handleNext()}>
                {i18n.t("got_it")}
            </StickyButton>
        </div>
    );
};

export default PromoZingAi;
